// extracted by mini-css-extract-plugin
module.exports = {"menu":"_1GSUx","surface":"_13Dz8","surfaceEnter":"WIwRM","surfaceEnterActive":"K1FNT","surfaceLeave":"IV94C","surfaceLeaveActive":"_5kWhz","links":"rtGGz","banner":"W1NA0"};